// @flow

import * as React from 'react';

import { compose } from 'redux';

import { withPageMeta } from '@gandi/app-runner';
import { selectCartUUID } from '@gandi/cart';

import { withRouter } from 'src/helpers/withRouter';
import { useAppSelector } from 'src/hooks/useAppSelector';

import { EmptyCart } from '../Overview/components/EmptyCart';
import { Layout } from '../components/Layout';
import type { WithRouterProps } from '../types';

type Props = WithRouterProps<>;

function FakeOverview(props: Props) {
  const cartId = useAppSelector(selectCartUUID);

  React.useEffect(() => {
    if (cartId) {
      props.navigate(`/cart/${cartId}`, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout>
      <EmptyCart />
    </Layout>
  );
}

export default (compose(
  withRouter,
  withPageMeta(args => ({
    title: args.__('Your shopping cart - Gandi.net'),
    description: args.__(
      'Review your shopping cart, add a promo code, review contracts, continue shopping.',
    ),
  })),
)(FakeOverview): React.ComponentType<{}>);
